module.exports = __webpack_public_path__ + "img/Effortless Mastery.710760f0.jpg";